// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__Si1gw","small":"IconButton_small__1VxxE","medium":"IconButton_medium__XxAlY","large":"IconButton_large__6YFux","disabled":"IconButton_disabled__VJARI"};